import React from "react";
import { useTranslation, Trans } from "next-i18next";
import '../styles/_product-tour.module.scss';

type Props = {
    tourSrc: string,
    title: string,
    tourId: string,
    description: string,
    titleChanged?:React.ReactNode
};

const ProductTour: React.FC<Props> = ({tourSrc, title, tourId, description, titleChanged}) => {
    const { t } = useTranslation("common");
    
    return <>
        <div className={"product-tour"} id={tourId}>
            <div className={"container"}>
                {titleChanged == undefined ? (
                    <h2>
                        <Trans
                            i18nKey="product.shared.productTour.defaultTitle"
                            components={{
                                highlight: <span className="text-gradient" />
                            }}
                        />
                    </h2>
                ) : titleChanged}
                <p>{description}</p>

                <div className={"tour"}>
                    <div className="iframe-container">
                        <iframe
                            src={tourSrc}
                            loading="lazy"
                            title={title}
                            allow="clipboard-write"
                            frameBorder="0"
                            webkitAllowFullScreen
                            mozAllowFullScreen
                            allowFullScreen
                            {...{webkitAllowFullScreen: true, mozAllowFullScreen: true} as any}
                        ></iframe>
                    </div>
                </div>

            </div>
        </div>
    </>
}

export default ProductTour;